// @ts-nocheck

import { downloadRequestWithToken, fetchRequest } from './index';
import { convertFromMToKm } from '../pure/unitConversions';
const convertFromServer = reportItem => ({
  ...reportItem,
  kilometrage: convertFromMToKm(reportItem.kilometrage)
});

/**
 * Получение отчета
 */
export const fetchReportArchiveVehicles = async params => {
  const report = await fetchRequest.get('/report/archiveVehicle', {
    ...params
  });
  return report.map(convertFromServer);
};

/**
 * Печать отчета
 */
export const printReportArchiveVehicles = async params => {
  const isPrinted = await downloadRequestWithToken('/report/archiveVehicle/print', {
    ...params
  });
  if (isPrinted) return true;
  throw new Error('Не удалось загрузить отчет');
};
export default {
  fetchReportArchiveVehicles,
  printReportArchiveVehicles
};
